import React from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
} from "antd";

import { ReactComponent as Visa } from "../assets/images/visa.svg";
import { ReactComponent as Hotel } from "../assets/images/hotel.svg";
import { ReactComponent as BreakFast } from "../assets/images/breakFast.svg";
import { ReactComponent as Transport } from "../assets/images/transport.svg";
import { Input } from "antd";
import activitiesImg from "../assets/images/activities.jpg";
import crazyDealImg from "../assets/images/crazyDeals.jpg";
import hotelImg from "../assets/images/hotel.jpg";
import holidayImg from "../assets/images/holiday.jpg";
import visaImg from "../assets/images/visa.jpg";
import cruiseImg from "../assets/images/cruise.jpg";
import spatialImg from "../assets/images/spe-1.jpg";
import spatialTowImg from "../assets/images/spe-2.jpg";
import spatialThreeImg from "../assets/images/spe-3.jpg";
import exploreCountryImg from "../assets/images/ex-country-1.jpg";
import exploreCountryTwoImg from "../assets/images/ex-country-2.jpg";
import exploreCountryThreeImg from "../assets/images/ex-country-3.jpg";
import sliderImg from "../assets/images/bannerHotel.jpg";
import { ReactComponent as CheckOutlinedCustom } from "../assets/images/checkbox-icon.svg";
import { ReactComponent as Accommodation } from "../assets/images/accommodation.svg";
import { ReactComponent as AllMeals } from "../assets/images/all-meals.svg";
import { ReactComponent as OnTourTransport } from "../assets/images/On-tour transport.svg";
import { ReactComponent as BestValueItinerary } from "../assets/images/best-value-itinerary.svg";
import { ReactComponent as TourManagers } from "../assets/images/tour-managers.svg";

import {
  GiftOutlined,
  DollarOutlined,
  HomeOutlined,
  CompassOutlined,
  FileDoneOutlined,
  RocketOutlined,
} from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import MegaMenu from "../components/MegaMenu";
import HotelSearchForm from "../components/HotelSearchForm";
import HotelSearchUI from "../components/HotelSearchForm";
import ExplorePlaces from "../components/ExplorePlaces";
import ReviewSlider from "../components/ReviewSlider";

const { Text, Paragraph } = Typography;
const categories = [
  {
    title: "Activities",
    desc: "your wanderlust awaits!",
    icon: <GiftOutlined />,
    img: activitiesImg,
  },
  {
    title: "Crazy Deals",
    desc: "Deal on Hotel and Flights",
    icon: <DollarOutlined />,
    img: crazyDealImg,
  },
  {
    title: "Hotel",
    desc: "your wanderlust awaits!",
    icon: <HomeOutlined />,
    img: hotelImg,
  },
  {
    title: "Holiday",
    desc: "your wanderlust awaits!",
    icon: <CompassOutlined />,
    img: holidayImg,
  },
  {
    title: "Visa",
    desc: "your wanderlust awaits!",
    icon: <FileDoneOutlined />,
    img: visaImg,
  },
  {
    title: "Cruise",
    desc: "your wanderlust awaits!",
    icon: <RocketOutlined />,
    img: cruiseImg,
  },
];

const offers = [
  {
    img: spatialImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialTowImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialThreeImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
];

const tours = [
  {
    id: 1,
    image: exploreCountryImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Standard",
    tagColor: "blue",
    badgeColor: "#10239E",
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Value",
    tagColor: "green",
    badgeColor: "#D72638",
  },
];

const highlights = [
  "Singapore and Bali Honeymoon Bliss | City Romance to Tropical Retreat",
  "Best Of Singapore | FREE Universal Studio Tickets Singapore & Malaysia Trip | FREE Night Safari Experience",
];

const toursForYou = [
  {
    title: "Best Selling UAE Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "International Tourist Visas",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Cruise Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Best Selling Singapore Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
];

const inclusiveTours = [
  {
    icon: <Accommodation />,
    title: "Accommodation",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <AllMeals />,
    title: "All meals",
    description: "Eat to your heart's content Breakfast. Lunch. Dinner.",
  },
  {
    icon: <OnTourTransport />,
    title: "On-tour transport",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <BestValueItinerary />,
    title: "Best value itinerary",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <TourManagers />,
    title: "Tour managers",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
];

const { Search } = Input;
const HotelDetailPage = () => {
  return (
    <>
      <section>
        <HotelSearchUI />
      </section>

      <section className="p-6 mt-28">
        <div className="container">
          {/* Header */}
          <div className="flex justify-between align-middle items-center mb-6">
            <h2 className="font-medium text-danger">
              <span className="text-primary">Special</span> Offers for Hotels
            </h2>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards */}
          <Row gutter={[16, 16]}>
            {offers.map((offer, index) => (
              <Col xs={24} sm={12} md={8} key={index}>
                <Card
                  className="flex rounded-[20px] overflow-hidden border-[#E5E5E5]"
                  styles={{
                    body: {
                      padding: "0px",
                      flex: "1",
                    },
                  }}
                >
                  <div className="flex">
                    {/* Left image with half-oval */}
                    <div className="relative w-[45%] overflow-hidden rounded-r-full">
                      <div className="absolute overflow-hidden rounded-r-full bg-black/10 w-[95%] h-[100%] "></div>
                      <img
                        src={offer.img}
                        alt={offer.title}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Right content */}
                    <div className="w-[55%] p-5 pl-4 pr-2 flex flex-col justify-center">
                      <h3 className="text-base mb-2 font-medium">
                        {offer.title}
                      </h3>
                      <p className="text-[9px] mb-4 font-normal">
                        {offer.desc}
                      </p>
                      <small className="text-[9px] mb-1 font-medium">
                        {offer.note}
                      </small>
                      <Button
                        type="danger"
                        size="middle"
                        className="px-6 mt-2 text-[11px] rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="p-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-3xl font-normal text-primary">
                Explore Hotels In <span className="text-danger">Europe</span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[40, 16]}>
            {tours.map((tour, index) => (
              <Col xs={24} md={8} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                        <div className="text-xl font-semibold text-white">
                          INR 1,43,200
                          <span className="line-through font-normal text-base ml-2">
                            INR 2,65,185
                          </span>
                        </div>
                        <div className="font-normal mt-1 text-white text-xs">
                          SAVE INR 1,21,985
                        </div>
                      </div>
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    {/* <div class="pt-3 bg-gray-100">This will have visible top padding</div> */}
                    <div className="mt-3 mb-2 text-muted text-[11px] font-medium">
                      Tour Type
                      <Tag className="bg-blue-100 text-black font-medium rounded border-0 text-[11px] ml-2">
                        {tour.type}
                      </Tag>
                    </div>

                    <div className="font-medium text-black text-lg leading-snug">
                      Best of Switzerland & Italy with <br />
                      FREE Excursion to Mount Titlis
                    </div>

                    <div className="text-primary mt-4 font-medium">
                      9 days & 8 nights
                    </div>

                    <div className="text-xs text-muted mt-1 space-x-1 font-medium">
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Rome →
                      <span className="text-red-500 font-semibold">1D</span>{" "}
                      Florence →{" "}
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Venice →{" "}
                      <span className="text-red-500 font-semibold">4D</span>{" "}
                      Zurich
                    </div>

                    {/* Buttons */}
                    <div className="flex mt-6 gap-3">
                      <Button
                        type="danger"
                        size="middle"
                        icon={<EyeOutlined className="text-xl" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                      <Button
                        size="middle"
                        type="default"
                        icon={<PhoneOutlined className="text-xl rotate-90" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-gray-500 px-6 py-2 rounded-lg"
                      >
                        Call US
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="p-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-3xl font-normal text-primary">
                Explore Hotels In <span className="text-danger">Maldives</span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[40, 16]}>
            {tours.map((tour, index) => (
              <Col xs={24} md={8} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                        <div className="text-xl font-semibold text-white">
                          INR 1,43,200
                          <span className="line-through font-normal text-base ml-2">
                            INR 2,65,185
                          </span>
                        </div>
                        <div className="font-normal mt-1 text-white text-xs">
                          SAVE INR 1,21,985
                        </div>
                      </div>
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    {/* <div class="pt-3 bg-gray-100">This will have visible top padding</div> */}
                    <div className="mt-3 mb-2 text-muted text-[11px] font-medium">
                      Tour Type
                      <Tag className="bg-blue-100 text-black font-medium rounded border-0 text-[11px] ml-2">
                        {tour.type}
                      </Tag>
                    </div>

                    <div className="font-medium text-black text-lg leading-snug">
                      Best of Switzerland & Italy with <br />
                      FREE Excursion to Mount Titlis
                    </div>

                    <div className="text-primary mt-4 font-medium">
                      9 days & 8 nights
                    </div>

                    <div className="text-xs text-muted mt-1 space-x-1 font-medium">
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Rome →
                      <span className="text-red-500 font-semibold">1D</span>{" "}
                      Florence →{" "}
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Venice →{" "}
                      <span className="text-red-500 font-semibold">4D</span>{" "}
                      Zurich
                    </div>

                    {/* Buttons */}
                    <div className="flex mt-6 gap-3">
                      <Button
                        type="danger"
                        size="middle"
                        icon={<EyeOutlined className="text-xl" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                      <Button
                        size="middle"
                        type="default"
                        icon={<PhoneOutlined className="text-xl rotate-90" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-gray-500 px-6 py-2 rounded-lg"
                      >
                        Call US
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="p-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-3xl font-normal text-primary">
                Explore Hotels In <span className="text-danger">Ladakh</span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[40, 16]}>
            {tours.map((tour, index) => (
              <Col xs={24} md={8} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                        <div className="text-xl font-semibold text-white">
                          INR 1,43,200
                          <span className="line-through font-normal text-base ml-2">
                            INR 2,65,185
                          </span>
                        </div>
                        <div className="font-normal mt-1 text-white text-xs">
                          SAVE INR 1,21,985
                        </div>
                      </div>
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    {/* <div class="pt-3 bg-gray-100">This will have visible top padding</div> */}
                    <div className="mt-3 mb-2 text-muted text-[11px] font-medium">
                      Tour Type
                      <Tag className="bg-blue-100 text-black font-medium rounded border-0 text-[11px] ml-2">
                        {tour.type}
                      </Tag>
                    </div>

                    <div className="font-medium text-black text-lg leading-snug">
                      Best of Switzerland & Italy with <br />
                      FREE Excursion to Mount Titlis
                    </div>

                    <div className="text-primary mt-4 font-medium">
                      9 days & 8 nights
                    </div>

                    <div className="text-xs text-muted mt-1 space-x-1 font-medium">
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Rome →
                      <span className="text-red-500 font-semibold">1D</span>{" "}
                      Florence →{" "}
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Venice →{" "}
                      <span className="text-red-500 font-semibold">4D</span>{" "}
                      Zurich
                    </div>

                    {/* Buttons */}
                    <div className="flex mt-6 gap-3">
                      <Button
                        type="danger"
                        size="middle"
                        icon={<EyeOutlined className="text-xl" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                      <Button
                        size="middle"
                        type="default"
                        icon={<PhoneOutlined className="text-xl rotate-90" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-gray-500 px-6 py-2 rounded-lg"
                      >
                        Call US
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>
      {/* Banner Slider  */}
      <section className="p-6">
        <div className="container">
          <Carousel
            autoplay
            dots
            className="rounded-2xl overflow-hidden shadow-lg"
          >
            <div className="flex items-center">
              <div className="absolute z-10 inset-0 bg-[linear-gradient(90deg,_rgba(221,21,21,0.8)_0%,_#EC1C1D_100%)]" />
              <Image
                src={sliderImg}
                alt="Slide 1"
                className="w-full !h-full object-cover"
                preview={false}
              />

              <Flex
                className="absolute z-20 inset-0 text-white px-12 py-8"
                align="start"
                justify="space-between"
              >
                <Flex flex={1} justify="space-between" className="" vertical>
                  <Flex justify="start" vertical align="start">
                    <Title
                      level={1}
                      className="!text-white rounded !font-medium !mb-0 !text-4xl"
                    >
                      Experience the Wow
                    </Title>

                    <Title
                      level={2}
                      className="!text-white uppercase rounded !text-5xl !mt-2 !mb-0"
                    >
                      in Every Stay
                    </Title>

                    {/* CTA Button */}
                    <Button
                      type="danger"
                      size="large"
                      className="font-medium text-xl bg-white mt-8 
                      border-none rounded-md px-16 py-8 text-[12273D] w-fit"
                    >
                      Book Now!
                    </Button>
                  </Flex>
                </Flex>

                <Flex
                  flex={1}
                  justify="center"
                  align="center"
                  className=""
                  vertical
                >
                  {/* Box Outline */}

                  <fieldset class="w-full mt-8 border-2 border-white border-solid rounded-[8px] p-6 text-white inline-block relative">
                    <legend class="px-4 w-auto text-xl font-semibold !mb-0 text-center">
                      STARTING PRISE
                    </legend>
                    {/* Diagonal Badge */}
                    <div className="absolute -top-5 -right-8 transform rotate-45 bg-blue-600 text-white text-lg font-bold px-3 py-[2px] shadow-md">
                      <Title
                        level={4}
                        className="!text-white !mb-0 !font-medium"
                      >
                        4N/5D
                      </Title>
                    </div>

                    {/* Price Text */}
                    <h1 className="large font-black leading-none text-center">
                      INR 35,999
                    </h1>
                    <p className="uppercase text-center text-xl font-semibold tracking-wide">
                      PER PERSON (BASED ON 2 PAX)
                    </p>
                  </fieldset>

                  <Flex
                    vertical
                    className="w-[60%] mx-auto"
                    justify="center"
                    align="center"
                  >
                    {/* Decorative Line */}
                    <div className="w-full h-[4px] bg-white rounded-full mt-10 mx-auto"></div>
                  </Flex>
                </Flex>
              </Flex>
            </div>
          </Carousel>
        </div>
      </section>

      <section className="p-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-3xl font-normal text-primary">
                Explore Hotels In <span className="text-danger">Singapore</span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[40, 16]}>
            {tours.map((tour, index) => (
              <Col xs={24} md={8} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                        <div className="text-xl font-semibold text-white">
                          INR 1,43,200
                          <span className="line-through font-normal text-base ml-2">
                            INR 2,65,185
                          </span>
                        </div>
                        <div className="font-normal mt-1 text-white text-xs">
                          SAVE INR 1,21,985
                        </div>
                      </div>
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    {/* <div class="pt-3 bg-gray-100">This will have visible top padding</div> */}
                    <div className="mt-3 mb-2 text-muted text-[11px] font-medium">
                      Tour Type
                      <Tag className="bg-blue-100 text-black font-medium rounded border-0 text-[11px] ml-2">
                        {tour.type}
                      </Tag>
                    </div>

                    <div className="font-medium text-black text-lg leading-snug">
                      Best of Switzerland & Italy with <br />
                      FREE Excursion to Mount Titlis
                    </div>

                    <div className="text-primary mt-4 font-medium">
                      9 days & 8 nights
                    </div>

                    <div className="text-xs text-muted mt-1 space-x-1 font-medium">
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Rome →
                      <span className="text-red-500 font-semibold">1D</span>{" "}
                      Florence →{" "}
                      <span className="text-red-500 font-semibold">2D</span>{" "}
                      Venice →{" "}
                      <span className="text-red-500 font-semibold">4D</span>{" "}
                      Zurich
                    </div>

                    {/* Buttons */}
                    <div className="flex mt-6 gap-3">
                      <Button
                        type="danger"
                        size="middle"
                        icon={<EyeOutlined className="text-xl" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md px-4 py-1 text-white w-fit"
                      >
                        View Details
                      </Button>
                      <Button
                        size="middle"
                        type="default"
                        icon={<PhoneOutlined className="text-xl rotate-90" />}
                        className="font-medium flex-1 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-gray-500 px-6 py-2 rounded-lg"
                      >
                        Call US
                      </Button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>
      <section className="p-6">
        <ReviewSlider />
      </section>
      <section className="p-6">
         <ExplorePlaces />
      </section>
    </>
  );
};

export default HotelDetailPage;
